import type { ExternalTableSchema } from '@packages/table-builder';

export const emailLogsTable: ExternalTableSchema = {
  metadata: {
    title: 'Email Logs',
    entity: 'Notification',
  },

  dataSource: {
    endpoint: '/api/notification/api/app/notification/email-notification-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      Title: 'table.searchText',
      NotificationMedium: '',
      NotificationType: '',
      IsSent: '',
      IsSeen: '',
      Status: 'filters.status',
      Filter: '',
      IsActive: '',
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
    },
    filters: [
      {
        name: 'status',
        placeholder: 'Email Status',
        type: 'select',
        options: [
          { label: 'Sent', value: 'Sent' },
          { label: 'Not Sent', value: 'Not Sent' },
          { label: 'Resending In Progress', value: 'Resending In Progress' },
        ],
      },
    ],
  },

  columns: [
    { field: 'title', header: 'Title', type: 'text', sortable: true, width: 250 },
    { field: 'from', header: 'From', type: 'text', width: 250 },
    { field: 'to', header: 'To', type: 'text', width: 200 },
    { field: 'descriptionTitle', header: 'Description', type: 'text', width: 250 },
    {
      field: 'notificationMedium',
      header: 'Notification Medium',
      type: 'text',
      sortable: true,
      width: 250,
    },
    {
      field: 'notificationType',
      header: 'Notification Type',
      type: 'text',
      sortable: true,
      width: 500,
    },
    {
      field: 'status',
      header: 'Email Status',
      type: 'badge',
      sortable: true,
      align: 'center',
      width: 150,
      conditionalValues: {
        Sent: 'Sent',
        'Not Sent': 'Not Sent',
        'Resending In Progress': 'Resending In Progress',
      },
      badge: {
        statusMap: {
          Sent: 'success',
          'Not Sent': 'error',
          'Resending In Progress': 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'creationTime',
      header: 'Creation Time',
      type: 'dateTime',
      sortable: true,
      width: 150,
      emptyDisplay: '-',
    },
  ],

  actions: {
    bulk: [{ id: 'BULK_RESEND_EMAIL_LOGS', label: 'Bulk Resend Email', icon: 'delete' }],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: {
      keyField: 'id',
      selectable: { field: 'status', operator: 'EQUAL', value: 'Not Sent' },
    },
  },
};
